import { BaseError } from './base';

type NotWaasWalletAccountErrorParams = {
  walletAddress: string;
};

export class NotWaasWalletAccountError extends BaseError {
  constructor({ walletAddress }: NotWaasWalletAccountErrorParams) {
    super({
      cause: null,
      code: 'not_waas_wallet_account_error',
      docsUrl: null,
      name: 'NotWaasWalletAccountError',
      shortMessage: `Wallet account ${walletAddress} is not a Dynamic WaaS wallet account`,
    });
  }
}
